import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserFeedbackSvg = function UserFeedbackSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 25",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.885 2.249c1.403-.002 2.79.3 4.068.883.769.35 1.487.798 2.14 1.331V2.481h1.379v4.417h-4.368V5.503h2.067a8.405 8.405 0 0 0-5.284-1.86c-4.699 0-8.508 3.851-8.508 8.602 0 .9.137 1.766.39 2.58l-1.316.418A10 10 0 0 1 2 12.245c0-5.52 4.425-9.996 9.885-9.996M12.239 22.248a9.8 9.8 0 0 1-4.079-.831 9.9 9.9 0 0 1-2.482-1.575v2.166h-1.38V17.59h4.369v1.395H6.818a8.404 8.404 0 0 0 5.402 1.868c4.698-.06 8.459-3.959 8.4-8.708a8.7 8.7 0 0 0-.421-2.575l1.31-.436c.307.944.477 1.95.49 2.993.069 5.52-4.301 10.05-9.76 10.12",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "m11.459 15.255 3.781-5.397-1.126-.806-2.836 4.048-1.664-1.682-.975.986z"
    })]
  });
};
export var UserFeedback = function UserFeedback(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: UserFeedbackSvg
  }));
};